import type { ReactNode } from 'react'

import { Skeleton } from '@/components/ui/skeleton'

interface PageLoadingProps {
    variant?: 'dashboard' | 'list' | 'detail'
}

const PageLoading = ({ variant = 'list' }: PageLoadingProps): ReactNode => {
    return (
        <div aria-busy='true' aria-live='polite' className='animate-in fade-in duration-300'>
            <span className='sr-only'>Loading clinic data</span>

            <div className='mb-6 flex items-end justify-between gap-4'>
                <div className='grid gap-2'>
                    <Skeleton className='h-7 w-48' />
                    <Skeleton className='h-4 w-72 max-w-full' />
                </div>
                <Skeleton className='hidden h-9 w-36 sm:block' />
            </div>

            {variant === 'dashboard' && (
                <div className='grid gap-4 sm:grid-cols-2 xl:grid-cols-4'>
                    {Array.from({ length: 8 }, (_, index) => (
                        <Skeleton key={index} className='h-36 rounded-xl' />
                    ))}
                </div>
            )}

            {variant === 'detail' && (
                <div className='grid gap-4'>
                    <Skeleton className='h-32 rounded-xl' />
                    <Skeleton className='h-9 w-full max-w-lg' />
                    <Skeleton className='h-72 rounded-xl' />
                </div>
            )}

            {variant === 'list' && (
                <div className='rounded-xl border border-border/80 bg-card p-4 shadow-card'>
                    <div className='mb-4 flex gap-3'>
                        <Skeleton className='h-9 flex-1' />
                        <Skeleton className='h-9 w-32' />
                    </div>
                    <div className='grid gap-3'>
                        {Array.from({ length: 6 }, (_, index) => (
                            <Skeleton key={index} className='h-11' />
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default PageLoading
